/* Pricing page plan builder (sections/plan-builder.liquid) – see docs/features/pricing-plan-builder.md */
(function (root) {
  var PRODUCTS = ['library', 'easymaker', 'bundle'];
  // Plan lengths in months, as in the variant SKUs (PS-5U-24M-LIC). 12 is the default.
  var TERMS = ['12', '24', '36'];

  var PlanBuilder = {
    TERMS: TERMS,

    // Replace each [key] in a setting's text; unknown keys stay as written.
    fill: function (text, values) {
      return String(text || '').replace(/\[(\w+)\]/g, function (match, key) {
        return values[key] != null ? values[key] : match;
      });
    },

    // A size's figures for one term. Liquid writes a term only when the store has its plan
    // (and, where the size has CHANGE, its CHANGE) variants, so a missing one is null.
    figures: function (size, term) {
      return (size && size.terms && size.terms[term || '12']) || null;
    },

    termAvailable: function (size, term) {
      return !!PlanBuilder.figures(size, term);
    },

    // The term actually used: the chosen one when the size has it, else 1 year
    termFor: function (size, term) {
      term = String(term || '12');
      return PlanBuilder.termAvailable(size, term) ? term : '12';
    },

    // Whether to ask "How long for?" at all: not until the store has 2- or 3-year variants
    hasMultiYear: function (sizes) {
      return (sizes || []).some(function (size) {
        return PlanBuilder.termAvailable(size, '24') || PlanBuilder.termAvailable(size, '36');
      });
    },

    // ?term=24|36 from a saved quote's link or a redirected 2- or 3-year product page
    termParam: function (value) {
      return value === '24' || value === '36' ? value : null;
    },

    years: function (term) {
      return Number(term || 12) / 12;
    },

    // Inspired by CHANGE goes with Photo Library or the Easy Read Bundle at the
    // same size, never EasyMaker on its own. Liquid leaves change null when the
    // store has no CHANGE variant for the size.
    changeAllowed: function (size, product, term) {
      var t = PlanBuilder.figures(size, PlanBuilder.termFor(size, term));
      return !!(t && t.change) && (product === 'library' || product === 'bundle');
    },

    // What the chosen plan costs for the whole term, with CHANGE when chosen and allowed
    priced: function (size, product, wantsChange, term) {
      var t = PlanBuilder.figures(size, term);
      if (wantsChange && PlanBuilder.changeAllowed(size, product, term)) return t.totals[product === 'bundle' ? 'bundle_change' : 'library_change'];
      return t[product];
    },

    // Each "How long for?" card's figure: the total for that term, for the current choice
    termPrice: function (size, product, wantsChange, term) {
      if (!PlanBuilder.termAvailable(size, term)) return '';
      return PlanBuilder.priced(size, product, wantsChange, term).price;
    },

    // Everything the summary shows. Every figure arrives formatted by Liquid,
    // so this only picks strings – no money maths in JavaScript.
    summary: function (size, product, wantsChange, copy, term) {
      term = PlanBuilder.termFor(size, term);
      var t = PlanBuilder.figures(size, term);
      var multi = term !== '12';
      var years = PlanBuilder.years(term);
      var allowed = PlanBuilder.changeAllowed(size, product, term);
      var withChange = allowed && !!wantsChange;
      var lines = [];
      var names = copy.products || {};

      if (product === 'bundle') {
        // Said as "Photo Library + EasyMaker at 40% off", the same way as CHANGE.
        lines.push({ label: PlanBuilder.fill(copy.plan_line, { size: size.name, product: names.library }), note: size.who, amount: t.library.price });
        lines.push({ label: copy.em_line, note: PlanBuilder.fill(copy.em_note, { percent: t.bundle.em_percent }), amount: t.bundle.em_part });
      } else {
        lines.push({ label: PlanBuilder.fill(copy.plan_line, { size: size.name, product: names[product] }), note: size.who, amount: t[product].price });
      }

      if (withChange) {
        lines.push({ label: copy.change_line, note: PlanBuilder.fill(copy.change_note, { size: size.name, percent: t.change.percent }), amount: t.change.price });
      } else {
        lines.push({ label: copy.change_line, note: allowed ? copy.change_not_added : copy.change_not_available, amount: null });
      }

      var priced = PlanBuilder.priced(size, product, withChange, term);

      // One figure only: the lines above already say where each discount comes from.
      // Liquid works it out per combination, the multi-year discount included.
      var amount = (t.savings || {})[product + (withChange ? '_change' : '')];
      var saving = '';
      if (amount) saving = PlanBuilder.fill(multi ? copy.save_term : copy.save_one, { amount: amount, years: years });

      return {
        term: term,
        allowed: allowed,
        withChange: withChange,
        lines: lines,
        total: priced.price,
        totalInc: priced.price_inc || '',
        per: multi ? PlanBuilder.fill(copy.per_term, { years: years }) : copy.per_year_short,
        saving: saving
      };
    },

    // ?plan=<product handle> from a redirected plan product page (sections/plan-product-redirect.liquid),
    // or ?plan=quote for Enterprise. Matched against each size's own product handles, so the
    // section's blocks are the only list of plans. Radio values are strings.
    selectionFor: function (sizes, plan) {
      if (!plan) return null;
      if (plan === 'quote') return { size: 'quote', product: null };
      for (var i = 0; i < sizes.length; i++) {
        var handles = sizes[i].handles || {};
        for (var j = 0; j < PRODUCTS.length; j++) {
          if (handles[PRODUCTS[j]] === plan) return { size: String(i), product: PRODUCTS[j] };
        }
      }
      return null;
    },

    // One /cart/add.js call: the term's plan variant, plus the same size and term's CHANGE
    // variant, quantity 1 each – the term is in the variant (PS-5U-24M-LIC), not the quantity.
    cartItems: function (size, product, wantsChange, term) {
      term = PlanBuilder.termFor(size, term);
      var t = PlanBuilder.figures(size, term);
      var items = [{ id: t[product].id, quantity: 1 }];
      if (wantsChange && PlanBuilder.changeAllowed(size, product, term)) items.push({ id: t.change.id, quantity: 1 });
      return items;
    },

    // Basket lines this add replaces: any 1-, 2- or 3-year plan (PS/ES, LIC or BND) or CHANGE
    // line, so changing your mind and adding again leaves one plan, not two plans and two CHANGE
    // lines that the basket guard rejects. Training, Extended Use (0U) and others stay.
    planLineKeys: function (items) {
      return (items || []).filter(function (item) {
        return /^(PS|ES)-[1-9]\d*U-(12|24|36)M-(LIC|BND|CHG)$/.test(item.sku || '');
      }).map(function (item) { return item.key; });
    },

    // "Do you want AI pictures too?" (Trello #6898): Yes is first and chosen, so only an
    // explicit "no" is No. ps_shopify's AiPicturesChoice reads the order's "AI pictures"
    // note attribute (this cart attribute): No adds no_ai_photos, Yes removes it.
    aiAnswer: function (value) {
      return value === 'no' ? 'no' : 'yes';
    },

    cartAttributes: function (ai) {
      return { 'AI pictures': PlanBuilder.aiAnswer(ai) === 'no' ? 'No' : 'Yes' };
    },

    // The summary's AI pictures line: free with Yes, unpriced ("–") with No
    aiLine: function (ai, copy) {
      if (PlanBuilder.aiAnswer(ai) === 'no') return { label: copy.ai_line, note: copy.ai_no_note, amount: null };
      return { label: copy.ai_line, note: copy.ai_yes_note, amount: copy.ai_yes_amount };
    },

    // CHANGE pictures are AI-assisted, so with AI pictures No the customer sees the original
    // CHANGE drawings instead. Warn, don't block (Martin, 2 Nov 2026).
    changeNeedsAiWarning: function (wantsChange, ai, allowed) {
      return !!(wantsChange && allowed) && PlanBuilder.aiAnswer(ai) === 'no';
    },

    // "More than 25 people": CHANGE is in the quote, at the largest size's discount
    quoteChange: function (sizes, copy) {
      var largest = PlanBuilder.figures(sizes[sizes.length - 1], '12');
      if (!largest || !largest.change) return '';
      return PlanBuilder.fill(copy.change_quote, { percent: largest.change.percent });
    },

    // "5 October 2026" – written out, so the browser's locale can't make it 10/5/2026
    longDate: function (date) {
      var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      return date.getDate() + ' ' + months[date.getMonth()] + ' ' + date.getFullYear();
    },

    // "Save my quote": what the print-only sheet shows, for the visitor to save as a PDF
    // and send to their manager. Only the priced lines – a manager doesn't need "Not added".
    // The link chooses the same plan again, with CHANGE when it's in the quote and the term
    // when it's 2 or 3 years, and AI pictures No when that was the answer. Without an `ai`
    // answer there is no AI line.
    quoteSheet: function (size, product, wantsChange, copy, date, term, ai) {
      var s = PlanBuilder.summary(size, product, wantsChange, copy, term);
      var multi = s.term !== '12';
      var years = { years: PlanBuilder.years(s.term) };
      var dateText = PlanBuilder.longDate(date);
      var plan = PlanBuilder.fill(copy.plan_line, { size: size.name, product: (copy.products || {})[product] });
      var url = copy.pricing_url + '?plan=' + encodeURIComponent(size.handles[product]);
      if (s.withChange) url += '&change=yes';
      if (multi) url += '&term=' + s.term;
      var lines = s.lines.filter(function (line) { return line.amount != null; });
      if (ai) {
        var aiLine = PlanBuilder.aiLine(ai, copy);
        lines.push({ label: aiLine.label, note: aiLine.note, amount: aiLine.amount == null ? '–' : aiLine.amount });
        if (PlanBuilder.aiAnswer(ai) === 'no') url += '&ai=no';
      }
      return {
        title: PlanBuilder.fill(copy.sheet_title, { plan: plan, date: dateText }),
        dated: PlanBuilder.fill(copy.sheet_dated, { date: dateText }),
        amountHeading: multi ? PlanBuilder.fill(copy.sheet_amount_term, years) : copy.sheet_amount,
        totalLabel: multi ? PlanBuilder.fill(copy.sheet_total_term, years) : copy.sheet_total,
        small: multi ? PlanBuilder.fill(copy.sheet_small_term, years) : copy.sheet_small,
        lines: lines,
        total: s.total,
        totalInc: s.totalInc ? PlanBuilder.fill(copy.inc_vat, { price: s.totalInc }) : '',
        saving: s.saving,
        url: url
      };
    },

    // Liquid's money filters can use HTML entities (&pound;). DOMParser decodes
    // them without running anything, and the result goes in as text.
    decode: function (value) {
      if (value == null) return '';
      if (!root.DOMParser || String(value).indexOf('&') === -1) return String(value);
      return new root.DOMParser().parseFromString('<!doctype html><body>' + value, 'text/html').body.textContent;
    }
  };

  // ---------- page wiring ----------
  function setText(el, value) { if (el) el.textContent = PlanBuilder.decode(value); }
  function all(scope, selector) { return Array.prototype.slice.call(scope.querySelectorAll(selector)); }
  function checked(form, name) { var el = form.querySelector('input[name="' + name + '"]:checked'); return el ? el.value : null; }

  // "How long for?" (only on the page once the store has 2- or 3-year variants). A term the
  // size doesn't have is disabled; a chosen one falls back to 1 year and comes back, like the
  // CHANGE answer, when the customer moves to a size that has it. Returns the term in use.
  function renderTerms(container, size, product, isQuote) {
    var form = container.querySelector('[data-pb-form]');
    var question = container.querySelector('[data-pb-term-question]');
    if (!question) return '12';
    var copy = container._pbData.copy;
    var chosen = checked(form, 'pb-term') || '12';
    if (!isQuote && container._pbWantsTerm && PlanBuilder.termAvailable(size, container._pbWantsTerm)) {
      chosen = container._pbWantsTerm;
      container._pbWantsTerm = null;
    } else if (isQuote || !PlanBuilder.termAvailable(size, chosen)) {
      if (chosen !== '12') container._pbWantsTerm = chosen;
      chosen = '12';
    }
    all(form, 'input[name="pb-term"]').forEach(function (input) {
      input.checked = input.value === chosen;
      input.disabled = isQuote || !PlanBuilder.termAvailable(size, input.value);
    });
    question.classList.toggle('is-off', isQuote);
    container.querySelector('[data-pb-term-off]').hidden = !isQuote;
    all(container, '[data-pb-term-note]').forEach(function (el) {
      var t = !isQuote && PlanBuilder.figures(size, el.dataset.pbTermNote);
      setText(el, t ? PlanBuilder.fill(copy.term_note, { percent: t.percent }) : '');
    });
    if (isQuote) all(container, '[data-pb-term-price]').forEach(function (el) { el.textContent = ''; });
    return chosen;
  }

  function render(container) {
    var data = container._pbData;
    var form = container.querySelector('[data-pb-form]');
    var sizeValue = checked(form, 'pb-size');
    var product = checked(form, 'pb-product') || 'library';
    var isQuote = sizeValue === 'quote';
    var size = isQuote ? null : data.sizes[Number(sizeValue)];
    var shown = size || data.sizes[0];
    var copy = data.copy;
    var termValue = renderTerms(container, size, product, isQuote);

    // Each size card shows its yearly price for the chosen product
    all(container, '[data-pb-size-price]').forEach(function (el) {
      var s = PlanBuilder.figures(data.sizes[Number(el.dataset.pbSizePrice)], '12');
      setText(el, PlanBuilder.fill(copy.per_year, { price: s[product].price }));
    });
    // Each product option shows its yearly price at the chosen size
    var yearly = PlanBuilder.figures(shown, '12');
    PRODUCTS.forEach(function (p) {
      setText(container.querySelector('[data-pb-product-price="' + p + '"]'), isQuote ? copy.quote_price : yearly[p].price);
    });
    // No size, no figures: a quote shows no Bundle saving rather than another size's
    setText(container.querySelector('[data-pb-bundle-note]'), isQuote ? '' : PlanBuilder.fill(copy.bundle_note, {
      percent: yearly.bundle.em_percent, em_part: yearly.bundle.em_part, em_price: yearly.easymaker.price
    }));

    // CHANGE question: the two answers are disabled, not hidden, with EasyMaker alone
    var allowed = isQuote ? product !== 'easymaker' : PlanBuilder.changeAllowed(size, product, termValue);
    var yes = form.querySelector('input[name="pb-change"][value="yes"]');
    var no = form.querySelector('input[name="pb-change"][value="no"]');
    var question = container.querySelector('[data-pb-change-question]');
    if (!allowed && yes.checked) { container._pbWantsChange = true; no.checked = true; }
    if (allowed && container._pbWantsChange) { yes.checked = true; container._pbWantsChange = false; }
    yes.disabled = no.disabled = !allowed;
    question.classList.toggle('is-off', !allowed);
    container.querySelector('[data-pb-change-off]').hidden = allowed;
    // Always rewritten, so a size without CHANGE doesn't keep the previous size's price
    var changePrice = '';
    if (isQuote) changePrice = PlanBuilder.quoteChange(data.sizes, copy);
    else if (yearly.change) changePrice = PlanBuilder.fill(copy.change_price, { price: yearly.change.price, reference: yearly.change.reference, percent: yearly.change.percent });
    setText(container.querySelector('[data-pb-change-price]'), changePrice);

    // AI pictures question: warn when CHANGE is chosen with No
    var ai = checked(form, 'pb-ai');
    var aiWarning = container.querySelector('[data-pb-ai-change]');
    if (aiWarning) aiWarning.hidden = !PlanBuilder.changeNeedsAiWarning(yes.checked, ai, allowed);

    // Summary
    container.querySelector('[data-pb-priced]').hidden = isQuote;
    container.querySelector('[data-pb-quote]').hidden = !isQuote;
    container.querySelector('[data-pb-add]').hidden = isQuote;
    container.querySelector('[data-pb-quote-link]').hidden = !isQuote;
    container.querySelector('[data-pb-save-quote]').hidden = isQuote;
    container.querySelector('[data-pb-save-quote-hint]').hidden = isQuote;
    container.querySelector('[data-pb-error]').textContent = '';
    if (isQuote) return;

    var s = PlanBuilder.summary(size, product, yes.checked, copy, termValue);
    // The "How long for?" cards show each term's total for this choice
    all(container, '[data-pb-term-price]').forEach(function (el) {
      var term = el.dataset.pbTermPrice;
      setText(el, PlanBuilder.termAvailable(size, term) ? PlanBuilder.termPrice(size, product, yes.checked, term) : copy.term_not_available);
    });
    var list = container.querySelector('[data-pb-lines]');
    list.textContent = '';
    var lines = ai ? s.lines.concat([PlanBuilder.aiLine(ai, copy)]) : s.lines;
    lines.forEach(function (line) {
      var li = root.document.createElement('li');
      if (line.amount == null) li.className = 'is-none';
      var what = root.document.createElement('span');
      what.className = 'pb-summary__what';
      var label = root.document.createElement('span');
      setText(label, line.label);
      var note = root.document.createElement('span');
      note.className = 'pb-summary__note';
      setText(note, line.note);
      what.appendChild(label);
      what.appendChild(note);
      var amount = root.document.createElement('span');
      amount.className = 'pb-summary__amount';
      setText(amount, line.amount == null ? '–' : line.amount);
      li.appendChild(what);
      li.appendChild(amount);
      list.appendChild(li);
    });
    setText(container.querySelector('[data-pb-total]'), s.total);
    setText(container.querySelector('[data-pb-per]'), s.per);
    var inc = container.querySelector('[data-pb-total-inc]');
    setText(inc, s.totalInc ? PlanBuilder.fill(copy.inc_vat, { price: s.totalInc }) : '');
    inc.hidden = !s.totalInc;
    setText(container.querySelector('[data-pb-save]'), s.saving);
  }

  function add(container, button) {
    var data = container._pbData;
    var form = container.querySelector('[data-pb-form]');
    var size = data.sizes[Number(checked(form, 'pb-size'))];
    var product = checked(form, 'pb-product');
    var wantsChange = checked(form, 'pb-change') === 'yes';
    var term = checked(form, 'pb-term') || '12';
    var ai = checked(form, 'pb-ai');
    var error = container.querySelector('[data-pb-error]');
    var cartRoot = (root.Shopify && root.Shopify.routes && root.Shopify.routes.root) || '/';
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    // Only Shopify's own description is shown; a network failure or an HTML error page
    // gets the add_error copy, never "Failed to fetch" or a JSON parse message.
    function failed(response) {
      return response.json().catch(function () { return {}; }).then(function (body) {
        var err = new Error('cart request failed');
        err.shopify = body && body.description;
        throw err;
      });
    }
    function post(path, body) {
      return root.fetch(cartRoot + path, { method: 'POST', headers: headers, body: JSON.stringify(body) })
        .then(function (response) { return response.ok ? response : failed(response); });
    }
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    error.textContent = '';
    // The plan replaces any plan and CHANGE already in the basket (PlanBuilder.planLineKeys).
    // The same call sets the "AI pictures" cart attribute, which reaches the order.
    root.fetch(cartRoot + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) { return response.ok ? response.json() : failed(response); })
      .then(function (cart) {
        var body = { attributes: PlanBuilder.cartAttributes(ai) };
        var keys = PlanBuilder.planLineKeys(cart.items);
        if (keys.length) {
          body.updates = {};
          keys.forEach(function (key) { body.updates[key] = 0; });
        }
        return post('cart/update.js', body);
      })
      .then(function () { return post('cart/add.js', { items: PlanBuilder.cartItems(size, product, wantsChange, term) }); })
      .then(function () { root.location.href = cartRoot + 'cart'; })
      .catch(function (e) {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        error.textContent = (e && e.shopify) || data.copy.add_error;
      });
  }

  // One element with text, so nothing from the store's copy is read as HTML
  function el(tag, className, text) {
    var node = root.document.createElement(tag);
    if (className) node.className = className;
    if (text != null) setText(node, text);
    return node;
  }

  function quoteSheetElement(q, copy) {
    var sheet = el('div', 'pb-print');
    sheet.setAttribute('lang', 'en-GB');
    sheet.appendChild(el('p', 'pb-print__brand', copy.shop_name));
    sheet.appendChild(el('h1', 'pb-print__heading', copy.sheet_heading));
    sheet.appendChild(el('p', 'pb-print__dated', q.dated));

    var table = el('table', 'pb-print__table');
    var head = table.createTHead().insertRow();
    [copy.sheet_item, q.amountHeading].forEach(function (text) {
      var th = el('th', null, text);
      th.setAttribute('scope', 'col');
      head.appendChild(th);
    });
    var body = table.createTBody();
    q.lines.forEach(function (line) {
      var row = body.insertRow();
      var what = el('th', null, line.label);
      what.setAttribute('scope', 'row');
      if (line.note) what.appendChild(el('span', 'pb-print__note', line.note));
      row.appendChild(what);
      row.appendChild(el('td', null, line.amount));
    });
    var foot = table.createTFoot().insertRow();
    var totalLabel = el('th', null, q.totalLabel);
    totalLabel.setAttribute('scope', 'row');
    foot.appendChild(totalLabel);
    var total = el('td', null, q.total);
    if (q.totalInc) total.appendChild(el('span', 'pb-print__note', q.totalInc));
    foot.appendChild(total);
    sheet.appendChild(table);

    if (q.saving) sheet.appendChild(el('p', 'pb-print__saving', q.saving));
    sheet.appendChild(el('p', 'pb-print__small', q.small));
    // The whole address is the link's text, on a line of its own that never wraps: a PDF saved
    // through the macOS print dialog loses its links, and Preview then links the address it
    // reads in the text – only up to a line break
    sheet.appendChild(el('p', 'pb-print__buy', copy.sheet_buy));
    var link = el('a', 'pb-print__url', q.url);
    link.href = q.url;
    sheet.appendChild(link);
    sheet.appendChild(el('p', 'pb-print__contact', copy.sheet_contact));
    return sheet;
  }

  // "Save my quote": put the sheet in <body> (the print CSS shows only it) and open the
  // print dialog, where the visitor chooses Save as PDF. The page title is the PDF's
  // suggested file name while the dialog is open.
  function saveQuote(container) {
    var data = container._pbData;
    var form = container.querySelector('[data-pb-form]');
    var size = data.sizes[Number(checked(form, 'pb-size'))];
    if (!size) return;
    var q = PlanBuilder.quoteSheet(size, checked(form, 'pb-product'), checked(form, 'pb-change') === 'yes', data.copy, new Date(), checked(form, 'pb-term'), checked(form, 'pb-ai'));
    var doc = root.document;
    all(doc, 'body > .pb-print').forEach(function (old) { old.parentNode.removeChild(old); });
    doc.body.appendChild(quoteSheetElement(q, data.copy));
    var pageTitle = doc.title;
    doc.title = PlanBuilder.decode(q.title);
    // The sheet stays (hidden on screen): Safari can fire afterprint before it has drawn the page
    root.addEventListener('afterprint', function restore() {
      doc.title = pageTitle;
      root.removeEventListener('afterprint', restore);
    });
    root.print();
  }

  function init(container) {
    if (container._pbData) return;
    var data = null;
    try {
      data = JSON.parse(container.querySelector('[data-pb-data]').textContent);
    } catch (e) {
      if (root.console) root.console.error('Plan builder: could not read its data', e);
    }
    if (!data || !data.sizes || !data.sizes.length) {
      // Without data the summary can't work, so show the no-JavaScript product links instead.
      // With scripting on, a <noscript>'s content is its text: our own server-rendered HTML.
      var fallback = container.querySelector('noscript');
      if (fallback) container.insertAdjacentHTML('beforeend', fallback.textContent);
      return;
    }
    container._pbData = data;
    container.classList.add('is-ready');
    // Back from the basket restores the page from the back/forward cache with the button
    // still disabled from the add, so give it back. Back from another page (#6185: the
    // DateMaker/PictureMaker links) reloads it and the browser puts the customer's choices
    // back after the first render, so render again to match the summary to them
    var addButton = container.querySelector('[data-pb-add]');
    root.addEventListener('pageshow', function () {
      addButton.disabled = false;
      addButton.removeAttribute('aria-busy');
      render(container);
    });
    var params = root.URLSearchParams ? new root.URLSearchParams(root.location.search) : null;
    var form = container.querySelector('[data-pb-form]');
    var pick = PlanBuilder.selectionFor(container._pbData.sizes, params && params.get('plan'));
    // &term=24|36 from a saved quote's link or a 2- or 3-year product page; render() falls
    // back to 1 year, and remembers the choice, where the size doesn't have it
    var term = PlanBuilder.termParam(params && params.get('term'));
    var termInput = term && form.querySelector('input[name="pb-term"][value="' + term + '"]');
    if (termInput) termInput.checked = true;
    // &ai=no from a saved quote's link
    var aiNo = params && params.get('ai') === 'no' && form.querySelector('input[name="pb-ai"][value="no"]');
    if (aiNo) aiNo.checked = true;
    if (pick) {
      var sizeInput = form.querySelector('input[name="pb-size"][value="' + pick.size + '"]');
      var productInput = pick.product && form.querySelector('input[name="pb-product"][value="' + pick.product + '"]');
      if (sizeInput) sizeInput.checked = true;
      if (productInput) productInput.checked = true;
      // A saved quote's link (PlanBuilder.quoteSheet) asks for CHANGE too; render() undoes it where it isn't allowed
      if (params.get('change') === 'yes') form.querySelector('input[name="pb-change"][value="yes"]').checked = true;
    }
    container.querySelector('[data-pb-form]').addEventListener('change', function (evt) {
      // A length the customer picks replaces one remembered from a size that lacked it
      if (evt.target.name === 'pb-term') container._pbWantsTerm = null;
      render(container);
    });
    container.querySelector('[data-pb-add]').addEventListener('click', function (evt) { add(container, evt.currentTarget); });
    container.querySelector('[data-pb-save-quote]').addEventListener('click', function () { saveQuote(container); });
    var toggle = container.querySelector('[data-pb-toggle]');
    if (toggle) {
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        container.querySelector('[data-pb-summary]').classList.toggle('is-open', open);
        setText(toggle.querySelector('[data-pb-toggle-text]'), open ? toggle.dataset.hideText : toggle.dataset.showText);
      });
    }
    // Below 960px the summary is a fixed bar; its height pads the page and lifts the chat button
    var summary = container.querySelector('[data-pb-summary]');
    if (summary && root.ResizeObserver) {
      new root.ResizeObserver(function () {
        var fixed = root.getComputedStyle(summary).position === 'fixed';
        root.document.documentElement.style.setProperty('--pb-bar-h', fixed ? Math.ceil(summary.offsetHeight) + 'px' : '0px');
      }).observe(summary);
    }
    render(container);
  }

  if (root.document) {
    // The script is deferred, so the section is already parsed
    all(root.document, '[data-plan-builder]').forEach(init);
    // The theme editor re-renders a section without re-running its scripts
    root.document.addEventListener('shopify:section:load', function (evt) {
      all(evt.target, '[data-plan-builder]').forEach(init);
    });
  }

  root.PlanBuilder = PlanBuilder;
  if (typeof module !== 'undefined' && module.exports) module.exports = PlanBuilder;
})(typeof window !== 'undefined' ? window : globalThis);
